export default (agency_id, parent_store_id, terminal_model, token) => {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', '/api/v1/terminal_model_infos/?agency_id=' + agency_id + '&parent_store_id=' + parent_store_id + '&terminal_model=' + terminal_model, true)
  xhr.setRequestHeader( 'X-CSRF-Token', token)
  xhr.setRequestHeader('Content-Type', 'application/json')
  xhr.send()
  xhr.addEventListener('load', function(result) {
    if (result.currentTarget.status == 200) {
      if (result.currentTarget.responseText.length == 0) {
          return
      }
      const json = JSON.parse(result.currentTarget.responseText)

      if (json.nothing_setting === true) {
        alert('対応する接続設定がないので変更していません。端末機種や親加盟店の設定を確認してください。')
        return
      }

      // カード
      const cardCompanies = json.agency_dental_card_companies
      const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]')
      const nestedFields = document.getElementsByClassName('parent_store_card_company_nested_fields')
      reflectSettings('creditCard', cardCompanies, nestedFields, addNestedFieldsBtn)

      // 電子マネー
      const eMoneyCompanies = json.agency_dental_e_money_companies
      const addEMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]')
      const eMoneyNestedFields = document.getElementsByClassName('parent_store_e_money_company_nested_fields')
      reflectSettings('eMoney', eMoneyCompanies, eMoneyNestedFields, addEMoneyNestedFieldsBtn)

      // QRコード
      const qrCompanies = json.agency_dental_qr_code_companies
      const addQrNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]')
      const qrNestedFields = document.getElementsByClassName('parent_store_qr_code_company_nested_fields')
      reflectSettings('qrCode', qrCompanies, qrNestedFields, addQrNestedFieldsBtn)

    } else if (result.currentTarget.status == 404) {
      alert(result.currentTarget.responseText)
    } else {
      alert("API取得でエラーが発生しました")
    }
  })
}

class SettingParams {
  companyIdColumnName = ''

  cardCompanyElmsClassName = ''
  ratioElmsClassName = ''
  agencyRatioElmsClassName = ''
  brandIdElmsClassName = ''

  cardCompanyCssSelector = ''
  ratioCssSelector = ''
  agencyRatioCssSelector = ''
  brandIdCssSelector = ''

  setParams(cIdColumnName, ccElmsClassName, rElmsClassName, arElmsClassName, bIdElmsClassName, ccCssSelector, rCssSelector, arCssSelector, bIdCssSelector) {
    this.companyIdColumnName = cIdColumnName

    this.cardCompanyElmsClassName = ccElmsClassName
    this.ratioElmsClassName = rElmsClassName
    this.agencyRatioElmsClassName = arElmsClassName
    this.brandIdElmsClassName = bIdElmsClassName

    this.cardCompanyCssSelector = ccCssSelector
    this.ratioCssSelector = rCssSelector
    this.agencyRatioCssSelector = arCssSelector
    this.brandIdCssSelector = bIdCssSelector
  }

  constructor(mode) {
    switch(mode) {
      case 'creditCard':
        this.setParams(
            'card_company_id',
            'parent_store_card_company',
            'parent_store_ratio',
            'parent_store_agency_sales_ratio',
            'parent_store_brand',
            '.parent_store_card_company',
            '.parent_store_ratio',
            '.parent_store_agency_sales_ratio',
            '.parent_store_brand'
        )
        break;
      case 'eMoney':
        this.setParams(
            'e_money_company_id',
            'parent_store_e_money_company',
            'parent_store_e_money_ratio',
            'parent_store_e_money_agency_sales_ratio',
            'parent_store_e_money_brand',
            '.parent_store_e_money_company',
            '.parent_store_e_money_ratio',
            '.parent_store_e_money_agency_sales_ratio',
            '.parent_store_e_money_brand'
        )
        break;
      case 'qrCode':
        this.setParams(
            'qr_code_company_id',
            'parent_store_qr_code_company',
            'parent_store_qr_code_ratio',
            'parent_store_qr_code_agency_sales_ratio',
            'parent_store_qr_code_brand',
            '.parent_store_qr_code_company',
            '.parent_store_qr_code_ratio',
            '.parent_store_qr_code_agency_sales_ratio',
            '.parent_store_qr_code_brand'
        )
        break;
      default:
        alert('実装エラー')
    }
  }
}

const reflectSettings = (mode, cardCompanies, nestedFields, addNestedFieldsBtn) => {
  const param = new SettingParams(mode)

  const tmpCardCompanies = cardCompanies
  loopTop:
      for(let i = 0; i < nestedFields.length; i++) {
        const nestedField = nestedFields[i]
        const nestedFieldsHiddenElm = nestedField.querySelector("input[type='hidden']")
        const cardCompanyElm = nestedField.querySelector(param.cardCompanyCssSelector)
        const ratioElm = nestedField.querySelector(param.ratioCssSelector)
        const agencyRatioElm = nestedField.querySelector(param.agencyRatioCssSelector)
        const brandIdElm = nestedField.querySelector(param.brandIdCssSelector)
        for(let j = 0; j < cardCompanies.length; j++) {
          if(cardCompanyElm.value === cardCompanies[j][param.companyIdColumnName].toString()) {
            nestedField.style.display = null
            nestedFieldsHiddenElm.value = false
            ratioElm.value = cardCompanies[j].ratio
            agencyRatioElm.value = cardCompanies[j].agency_sales_ratio
            brandIdElm.value = cardCompanies[j].brand_id
            tmpCardCompanies.splice(j, 1)
            continue loopTop
          }
        }
        const nextElm = nestedField.nextElementSibling
        if(nextElm != null && nextElm.tagName === 'INPUT') {
          nestedField.style.display = 'none'
          nestedFieldsHiddenElm.value = 1
        } else {
          nestedField.remove()
          i--
        }
      }
  for(let i = 0; i < tmpCardCompanies.length; i++) {
    addNestedFieldsBtn.click()
    const cardCompanyElms = document.getElementsByClassName(param.cardCompanyElmsClassName)
    cardCompanyElms[cardCompanyElms.length-1].value = tmpCardCompanies[i][param.companyIdColumnName]
    const ratioElms = document.getElementsByClassName(param.ratioElmsClassName)
    ratioElms[ratioElms.length-1].value = tmpCardCompanies[i].ratio
    const agencyRatioElms = document.getElementsByClassName(param.agencyRatioElmsClassName)
    agencyRatioElms[agencyRatioElms.length-1].value = tmpCardCompanies[i].agency_sales_ratio
    const brandIdElms = document.getElementsByClassName(param.brandIdElmsClassName)
    brandIdElms[brandIdElms.length-1].value = tmpCardCompanies[i].brand_id
  }
}